<mat-card style="padding: 0px">
    <div style="display: flex; align-items: flex-start; flex-flow: column wrap">
        <div style="min-width: 100%; padding: 0.5rem" *ngFor="let cal of this.CALFeature">
            <mat-card
                style="padding: 0px; min-width: 100%"
                [ngClass]="feature?.CurrNrOfUser > 0 ? 'MWSelectedFeature' : 'noSelectedFeature'"
            >
                <mat-card-content style="margin: 0; min-width: 100%">
                    <div [ngClass]="this.smallScreen ? 'flex-columns' : 'flex-row'" style="min-width: 100%; align-items: space-between">
                        <div [ngClass]="this.productID == 'MC' ? 'MCSelectionArea' : 'MWSelectionArea'">
                            <div style="display: flex; justify-content: flex-end; width: 100%">
                                <div style="margin-top: 0.2rem; margin-right: 0.1rem">
                                    <div class="wrapperNrUsersClass-small">
                                        <button class="plusminus-small" (click)="handleOptionMinus(cal)">-</button>
                                        <input
                                            [(ngModel)]="cal.CurrNrOfUser"
                                            [disabled]="cal.IsMandatory"
                                            [checked]="cal.isChecked || cal.IsMandatory"
                                            min="0"
                                            readonly
                                            class="num-small"
                                            onkeydown="return false"
                                        />
                                        <button class="plusminus-small" (click)="handleOptionPlus(cal)">+</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div [ngClass]="this.smallScreen ? 'verticalTitleDivStyle' : 'horizontalTitleDivStyle'">
                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    align-items: start;
                                    margin: 0px;
                                    padding: 0px;
                                    margin-bottom: 0.5rem;
                                    margin-top: 0.5rem;
                                    margin-left: 0.8rem;
                                    flex-grow: 8;
                                "
                            >
                                <div class="cardFeatureTitleContainer" [ngClass]="this.smallScreen ? 'flex-columns' : 'flex-row'">
                                    <div>
                                        <span class="cardFeatureTitle">{{ this.getDescription(cal) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div [ngClass]="this.productID == 'MC' ? 'orangeAreaPrice' : 'greenAreaPrice'">
        <div style="display: flex; justify-content: flex-end">
            <div class="areaPriceTitle" *ngIf="this.productID == 'MW'">
                <span translate>MAGOWEB_CONFIGURATION.TOTAL_CAL_NR</span>: <span> {{ this.magoWebService?.totalCalFullNr }}</span>
            </div>
            <div class="areaPriceTitle" *ngIf="this.productID == 'MC'">
                <span translate>MAGOWEB_CONFIGURATION.TOTAL_CAL_NR</span>: <span> {{ this.magoCloudService?.totalCalFullNr }}</span>
            </div>
        </div>
    </div>
</mat-card>
